
import createIcon from "./createIcon";

export const DiscIcon = createIcon('Disc', (props) => {
  return (
    <svg {...props} viewBox="0 0 36 36">
      <g style={{ opacity: 0.2 }}>
        <ellipse cx="18" cy="18" rx="18" ry="18" fill={props.color} fillOpacity="1" />
      </g>
      <g style={{ opacity: 0.2 }}>
        <ellipse cx="18" cy="18" rx="8" ry="8" fill={props.color} fillOpacity="1" />
      </g>
    </svg >
  )
});
